import { render, staticRenderFns } from "./Copier.vue?vue&type=template&id=efc2b96c"
import script from "./Copier.vue?vue&type=script&lang=js"
export * from "./Copier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports